import { SelectOption } from '@globaleris/ui.library'
import {
  apiClientGET,
  apiContractTypeGET,
  apiProductsGET,
  apiTemplateIdGET,
  apiTemplateSettingsCreate,
  apiTemplateSettingsGET,
  apiTemplateSettingsUpdate,
  apiUpdateListadoConceptosByProductId
} from '../../api/Argentia/endpoints/templateSettings/templateSettings.api'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../helpers/serviceResponseHelper'
import { ServiceResponse } from '../../model/serviceResponse'
import {
  listItemMapper,
  templateSettingsListItemMapper,
  templateSettingsListItemMapperAdd,
  templateSettingsListItemMapperEdit,
  templateSettingsListItemsMapper
} from './templateSettings.mapper'
import TemplateSettings, { TemplateSettingsAdd } from './templateSettings.model'

export const fetchTemplateSettingsListItems = async (): Promise<
  ServiceResponse<TemplateSettings[] | undefined>
> => {
  return apiTemplateSettingsGET()
    .then(response => {
      return createSuccessServiceResponse(templateSettingsListItemsMapper(response))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchProductsListItems = async (): Promise<ServiceResponse<any>> => {
  return apiProductsGET()
    .then(response => {
      return createSuccessServiceResponse(listItemMapper(response))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchContractTypeListItems = async (): Promise<
  ServiceResponse<SelectOption[] | undefined>
> => {
  return apiContractTypeGET()
    .then(response => {
      return createSuccessServiceResponse(listItemMapper(response))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchClientListItems = async (): Promise<
  ServiceResponse<SelectOption[] | undefined>
> => {
  return apiClientGET()
    .then(response => {
      return createSuccessServiceResponse(listItemMapper(response))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const FetchTemplateId = async (registerId: number): Promise<ServiceResponse<any>> => {
  return apiTemplateIdGET(registerId)
    .then(response => {
      return createSuccessServiceResponse(templateSettingsListItemMapper(response))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

// Update Template
export const updateTemplateSettings = async (
  formData: any,
  products: SelectOption[],
  contractTypes: SelectOption[],
  clients: SelectOption[]
): Promise<ServiceResponse<any>> => {
  return await apiTemplateSettingsUpdate(
    templateSettingsListItemMapperEdit(formData, products, contractTypes, clients)
  )
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const updateListadoConceptosByProductId = async (
  productId: number
): Promise<ServiceResponse<any>> => {
  return await apiUpdateListadoConceptosByProductId(productId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
//Create template configuration

export const createTemplateSettings = async (
  formData: TemplateSettingsAdd,
  products?: SelectOption[],
  contractTypes?: SelectOption[],
  clients?: SelectOption[]
): Promise<ServiceResponse<any>> => {
  return await apiTemplateSettingsCreate(
    templateSettingsListItemMapperAdd(formData, products, contractTypes, clients)
  )
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

//#region Handlers

export const canEditTemplates = (template: TemplateSettings | undefined): boolean => {
  return true
}
export const modifyTemplate = async (data: any): Promise<Boolean> => {
  return true
}
//#endregion
